/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { PageOfExportRecordsDto } from '../models/page-of-export-records-dto';

@Injectable({
  providedIn: 'root',
})
export class ExportService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation listExports
   */
  static readonly ListExportsPath = '/user-profile/exports';

  /**
   * Loads list of exports
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listExports()` instead.
   *
   * This method doesn't expect any request body.
   */
  listExports$Response(params: {
    page: number;
    size: number;
  }): Observable<StrictHttpResponse<PageOfExportRecordsDto>> {

    const rb = new RequestBuilder(this.rootUrl, ExportService.ListExportsPath, 'get');
    if (params) {
      rb.query('page', params.page, {});
      rb.query('size', params.size, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PageOfExportRecordsDto>;
      })
    );
  }

  /**
   * Loads list of exports
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `listExports$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listExports(params: {
    page: number;
    size: number;
  }): Observable<PageOfExportRecordsDto> {

    return this.listExports$Response(params).pipe(
      map((r: StrictHttpResponse<PageOfExportRecordsDto>) => r.body as PageOfExportRecordsDto)
    );
  }

}
